module.exports = __webpack_public_path__ + "img/guide_dog.f3ad5fe2.png";